module.exports = __webpack_public_path__ + "static/media/share-dots-light.46aee37f.png";